import { checkboxColumn, floatColumn, keyColumn } from "react-datasheet-grid";

import "./styles.css";
import { EmployeeLineItem } from "@interfaces/employee";
import { searchColumn } from "@stories/atoms/SpreadSheet/SpreadSheetSearch";
import {
  SocialCommitmentLineItem,
  SocialCommitmentTypeHour,
  socialCommitmentTypeHourToString,
} from "@interfaces/commitment";

export const getLabourHourColumns = (
  employees: EmployeeLineItem[],
  commitments: SocialCommitmentLineItem[],
  updateSocialFactors: (rowId: number, employeeId: string) => void,
  loading: boolean
) => {
  console.log("Loading - ", loading);
  const columns = [
    {
      ...keyColumn(
        "employeeId",
        searchColumn(
          {
            options: employees.map((e) => {
              return {
                value: e.id,
                label: e.employeeName,
              };
            }),
            selectedEmployee: (id: string) => {
              return employees.find((e) => e.id === id);
            },
            searchEmployees: (query: string) => {
              return employees
                .filter((e) => e.employeeName.includes(query))
                .map((e) => {
                  return { value: e.id, label: e.employeeName };
                });
            },
            updateSocialFactors: updateSocialFactors,
          },
          ({ rowData, value }) => {
            return value;
          }
        )
      ),
      title: "Employee Name",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
    },
    {
      ...(keyColumn("amount", floatColumn) as any),
      title: "Amount",
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
    },
  ];

  for (const sc of commitments) {
    columns.push({
      ...(keyColumn(`${sc.id}`, checkboxColumn) as any),
      title:
        sc.targetDescription ||
        socialCommitmentTypeHourToString(
          sc.targetName as SocialCommitmentTypeHour
        ),
      keepFocus: true,
      disableKeys: true,
      className: "row-font",
      disabled: loading,
    });
  }

  return columns;
};
